const alDisciplines = ['E', 'G', 'W', 'M', 'R']
const hlDisciplines = ['E', 'G', 'W', 'M', 'R', 'H']

const disciplines = alDisciplines

const disciplineLabels = {
  E: 'Elektra',
  G: 'Gas',
  W: 'Water',
  M: 'Media',
  R: 'Riool',
  H: 'Warmte',
}

type Discipline = keyof typeof disciplineLabels

/** INVARIANT: gelijk aan hlDisciplines, met de volgorde van disciplineLabels */
const hlDisciplineOptions = Object.keys(disciplineLabels) as Discipline[]

/** INVARIANT: gelijk aan alDisciplines, dus hlDisciplineOptions zonder Warmte (H) */
const alDisciplineOptions = hlDisciplineOptions.filter((discipline) =>
  alDisciplines.includes(discipline),
)

const filterByDisciplineCode = (arr, disciplineCode) =>
  arr && arr.filter((o) => o.disciplineCode === disciplineCode)
const getProducts = (arr) => (disciplineCode) =>
  filterByDisciplineCode(arr, disciplineCode)

const getProductsOrDefault = (arr) => (disciplineCode) => {
  const products = filterByDisciplineCode(arr, disciplineCode)

  return products && products.length > 0
    ? products
    : [{ disciplineCode, progress: 0 }]
}

export type { Discipline }

export {
  alDisciplines,
  hlDisciplines,
  disciplineLabels,
  hlDisciplineOptions,
  alDisciplineOptions,
  disciplines,
  getProductsOrDefault,
  getProducts,
}
